module.exports = __webpack_public_path__ + "media/images/ice-cream-47786622103cf95f40930fe37879ceb9.png";